import { Sun, Moon } from "lucide-react";
import { useTheme } from "../contexts/ThemeContext";

/**
 * Theme toggle floating en haut a droite, visible globalement sur toutes les pages.
 * Complement du toggle deja present dans la Sidebar : permet un acces rapide
 * sans avoir a ouvrir la sidebar (utile sur mobile en mode collapsed).
 */
export default function HeaderThemeToggle() {
  const { theme, toggle, isDark } = useTheme();

  return (
    <button
      onClick={toggle}
      data-testid="header-theme-toggle"
      aria-label={isDark ? "Passer en mode clair" : "Passer en mode sombre"}
      title={isDark ? "Mode clair" : "Mode sombre"}
      className="fixed top-3 right-3 z-30 hidden md:flex items-center justify-center w-10 h-10 rounded-full backdrop-blur-md transition-all duration-200 hover:scale-110 group"
      style={{
        background: isDark ? "rgba(20, 16, 28, 0.85)" : "rgba(255, 255, 255, 0.92)",
        border: `1px solid ${isDark ? "rgba(247, 201, 53, 0.25)" : "rgba(0, 0, 0, 0.08)"}`,
        boxShadow: isDark
          ? "0 4px 16px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(247, 201, 53, 0.1)"
          : "0 4px 16px rgba(0, 0, 0, 0.08)",
      }}
    >
      {theme === "dark" ? (
        <Sun className="w-4 h-4 text-[#f7c935] transition-transform duration-300 group-hover:rotate-90" />
      ) : (
        <Moon className="w-4 h-4 text-[#1a1025] transition-transform duration-300 group-hover:-rotate-12" />
      )}
    </button>
  );
}
